<template>
  <div class="offset-bar" :class="[isFixed ? 'isFixed':'']" v-if="isLogin && isBindTicket">
    <!-- :style="{backgroundImage: 'url('+imgUrl+'/barBg.png)'}" -->
    <div class="offset-bar-content" :class="[isFixed ? 'padding-gap':'',isShowbg?'gray-bg':'']">
      <div class="offset-bar-content__left">
        <img :src="imgUrl+'/dollarImage.png'" alt="">
        <div>您的舱房内还剩余<strong class="strong-dom">{{money}}</strong>美元船上消费抵用金</div>
      </div>
      <div class="offset-bar-content__right" @click="showCouponRule = true">
        行前订可用
      </div>
    </div>

    <custom-modal :visible.sync="showCouponRule" offsetfiftBar :title="obcDescription?obcDescriptionTitle:''" 
      :z-index="2000" 
      :modalWidth="600"
      :contentHeight="600">
      <template #body>
        <div v-html="obcDescription?obcDescription:''"></div>
      </template>
    </custom-modal>
  </div>
</template>
<script>

const imgUrl = process.env.VUE_APP_IMG_URL+'/rcclPcp/mb/obcBar';
import CustomModal from "@/components/CustomModal.vue";
import { mapState } from 'vuex'

export default {
  name: 'OffsetfiftyBar',
  components: {
    CustomModal,
  },
  props: {
    isFixed: {
      type: Boolean,
      default: false
    },
    isShowbg: {
      type: Boolean,
      default: false
    },
    money: {
      type: [Number,String],
      default: 0
    },
    
  },
  data () {
    return {
      imgUrl: imgUrl,
      showCouponRule:false,
    }
  },

  computed: {
    ...mapState(['commonInfo','token','bindTicket']),
    // 是否绑定船票
    isBindTicket() {
      // console.log('this.bindTicket', this.bindTicket)
      return !!this.bindTicket
    },
    // 是否登陆
    isLogin() {
      //  console.log('this.token', this.token)
      return !!this.token
    },
    obcDescriptionTitle() {

      if(this.commonInfo && this.commonInfo?.obcDescription && this.commonInfo?.obcDescription.title) {
        return this.commonInfo?.obcDescription.title
      }
      return  null
    },
    obcDescription() {

      if(this.commonInfo && this.commonInfo?.obcDescription && this.commonInfo?.obcDescription.content) {
        return this.commonInfo.obcDescription.content.replace("${ObcAmount}", this.money); 
        // return this.commonInfo.obcDescription.replace(/${ObcAmount}/g, this.money); 
      }
      return  null
    }
  },
  
  methods: {
    
    
  }
}
</script>
<style lang="less" scoped>
.offset-bar{
  width: 100%;
  height: 60px;
  padding: 0 20px;
  box-sizing: border-box;
  margin-bottom: 14px;
  .offset-bar-content{
    width: 100%;
    height: 100%;
    // background-size: cover;
    // background-repeat: no-repeat;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 10px;

    background: url('https://resource.rcclchina.com.cn/pcp/obc_line.png') top left;
    background-size: 100% 100%;
    
    .offset-bar-content__left{
      display: flex;
      align-items: center;
      img{
        width: 48px;
        height: 48px;
        margin-right: 10px;
      }
      div{
        font-weight: 500;
        font-size: 22px;
        color: #D67A07;
        line-height: 1;
        text-align: left;
        font-style: normal;
      }

    }
    .offset-bar-content__right{
      width: 148px;
      height: 40px;
      line-height: 43px;
      background: linear-gradient( 90deg, #FE8B76 0%, #FD3C51 100%);
      border-radius: 22px;
      font-weight: 400;
      font-size: 24px;
      color: #FFFFFF;
      font-style: normal;
      text-align: center;
      // display: flex;
      // align-items: center;
      // justify-content: center;
    }
  }
}
.isFixed{
  padding: 0;
  border-radius: 0;
}
.padding-gap{
  padding: 0 30px !important;
  border-radius: 0 !important;
  background: linear-gradient( 83deg, #faf5ed, rgba(238,154,49,0.53) 100%) !important;
}
.strong-dom{
   font-size: 30px;
   font-weight: bold;
}
.gray-bg{
  background-color: #f0f0f0 !important;
}
</style>